import { render, staticRenderFns } from "./RatingStar.vue?vue&type=template&id=374b2e00&scoped=true"
import script from "./RatingStar.vue?vue&type=script&lang=js"
export * from "./RatingStar.vue?vue&type=script&lang=js"
import style0 from "./RatingStar.vue?vue&type=style&index=0&id=374b2e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374b2e00",
  null
  
)

export default component.exports